import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useNavigate, useParams } from 'react-router-dom';
import { AccountTab, RoutePath, generateRoutePath } from '../../app/router/config';
import Header from '../../components/account/header';
import MyInfo from '../../components/account/my-info';
import Overview from '../../components/account/overview';
import Tools from '../../components/account/tools';
import Wallets from '../../components/account/wallets';
import { useVipProgram } from '../../hooks/cta-token/use-vip-program';
import Layout from '../../layout';
export default function Account() {
    var t = useI18n().t;
    var tab = useParams().tab;
    var navigate = useNavigate();
    var _a = useVipProgram(), perks = _a.perks, timeRemaining = _a.timeRemaining;
    if (!tab || !Object.values(AccountTab).includes(tab)) {
        navigate(generateRoutePath(RoutePath.ACCOUNT, { tab: AccountTab.OVERVIEW }), { replace: true });
        return _jsx(_Fragment, {});
    }
    var tabs = [
        {
            label: t('account.tabs.overview'),
            path: generateRoutePath(RoutePath.ACCOUNT, { tab: AccountTab.OVERVIEW }),
            selected: tab === AccountTab.OVERVIEW,
        },
        {
            label: t('account.tabs.my-info'),
            path: generateRoutePath(RoutePath.ACCOUNT, { tab: AccountTab.MY_INFO }),
            selected: tab === AccountTab.MY_INFO,
        },
        {
            label: t('account.tabs.wallets'),
            path: generateRoutePath(RoutePath.ACCOUNT, { tab: AccountTab.WALLETS }),
            selected: tab === AccountTab.WALLETS,
        },
        {
            label: t('account.tabs.tools'),
            path: generateRoutePath(RoutePath.ACCOUNT, { tab: AccountTab.TOOLS }),
            selected: tab === AccountTab.TOOLS,
        },
    ];
    return (_jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, { tabs: tabs, vipData: perks
                        ? {
                            currentLevel: perks.loyaltyLevel,
                            nextLevel: perks.nextLevelPerks ? perks.loyaltyLevel + 1 : undefined,
                            currentPoints: perks.loyaltyPoints,
                            goalPoints: perks.nextLevelPerks
                                ? perks.loyaltyLevelThresholds[perks.loyaltyLevel]
                                : perks.maxLoyaltyLevelThrehold,
                            daysRemaining: timeRemaining,
                        }
                        : undefined }), tab === AccountTab.OVERVIEW && _jsx(Overview, {}), tab === AccountTab.MY_INFO && _jsx(MyInfo, {}), tab === AccountTab.WALLETS && _jsx(Wallets, {}), tab === AccountTab.TOOLS && _jsx(Tools, {})] }) }));
}
